import _ from 'lodash';

export const formatName = (profile) => {
  const firstName = _.get(profile, 'firstName');
  const lastName = _.get(profile, 'lastName');
  const fullName = _.get(profile, 'fullName');
  return fullName || (!(_.isNil(firstName) && _.isNil(lastName)) ? `${firstName} ${lastName}` : 'unknown');
};

export const formatNameWithLastInitial = (profile) => {
  const formattedName = formatName(profile);
  const [firstName, lastName] = _.split(formattedName, ' ');

  // fullName could possibly be one name with no spaces. formatName can also just return 'unknown';
  if (!lastName) {
    return firstName;
  }

  return `${firstName} ${lastName[0]}.`;
};

export const isConsumerUser = (user) => Boolean(user?.profile?.type === 'user' || _.isNil(user?.profile?.type));

export const isSuperAdmin = (user) => Boolean(user?.profile?.type === 'superAdmin');

export const isDispensaryUser = (user) => Boolean(user?.profile?.type === 'dispensaryUser');

export const isInternalEmail = (email) =>
  _.includes(email, '@dutchie.com') || _.includes(email, '@leaflogix.com') || _.includes(email, '@greenbits.com');

export const isChainAdmin = (user) =>
  Boolean(
    user?.profile?.chainID &&
      isDispensaryUser(user) &&
      (user?.profile?.permissions?.allLocations || user?.profile?.permissions?.dispensaryIds?.length > 1)
  );

export const isAdminAccessible = (user) => isSuperAdmin(user) || isDispensaryUser(user) || isChainAdmin(user);

export const superAdminCan = (permissions, permission) => {
  let hasPermission = true;

  if (!_.isEmpty(permissions) && !permissions[permission]) {
    hasPermission = false;
  }

  if (permission === 'menuReview' && !permissions?.menuReview) {
    hasPermission = false;
  }

  return hasPermission;
};
